import React from 'react';
import moment from 'moment';
import {NotificationManager} from 'react-notifications';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import connection from '../../../connection';
import {Col, Container, Row, Button} from "react-bootstrap";
import ScaleLoader from "react-spinners/ScaleLoader";
import {getLeaguePlayerBDetails, getOffersForLeague, getOffersForTournament} from '../../../services/enrollments';
import {searchUser} from "../../../services/leagues";
import {isFilled} from "../../../utils";
import {withTranslation} from "react-i18next";

// React Components
import Header from '../../../components/Header/Header';
import Input from '../../../components/Input/Input';
import InputSelect from '../../../components/InputSelect/InputSelect';
import InputRadio from '../../../components/InputRadio/InputRadio';
import BulletHeader from "../../../components/BulletHeader/BulletHeader";

// CSS Files
import './styles.css';

const MySwal = withReactContent(Swal);

const override = `
    position: absolute;
    top: 30px;
    margin-left: auto;
    margin-right: auto;
    text-align: center;
    left: 0;
    right: 0;
    background-color: rgba(255,255,255,0.7);
`;

class PlayerTwoRegistration extends React.Component {
   constructor(props) {
      super(props)

      this.timeout = 0;

      this.state = {
         original_details: {},
         id: '',
         name: '',
         email: '',
         gender: '',
         birthyear: '',
         federated_fpp: false,
         fpp_licence: '',
         site_url: '',
         offer_id: '',
         offer_size_id: '',
         phone_number: '',
         social_media: false,
         single_enrollment: false,
         offers: [],
         searching: false,
         found: false,
         free_email: false,
         info_new_player: ''
      }
   }

   async componentDidMount() {
      this.getOffers();

      if (typeof this.props.formData.partner_registration === 'undefined') {
         if (this.props.formData.is_replication) {
            if (this.props.formData.replication_is_league) {
               await this.getLeaguePlayerDetails();
            } else {
               await this.getTournamentPlayerDetails();
            }
         }
      } else {
         this.setState(this.props.formData.partner_registration)
      }
   }

   render() {
      const {t} = this.props;
      const options = [];

      for (let i = moment().subtract(70, 'years').format('YYYY'); i < moment().subtract(11, 'years').format('YYYY'); i++) {
         options.push(i)
      }

      let sizes = this.getSizesForOffer(this.state.offer_id)

      if (this.state.offer_id !== '') {
         var offer_found = false;
         this.state.offers.map((offer) => {
            if (offer.id == this.state.offer_id) {
               offer_found = true;
            }
         })
         if (!offer_found) {
            this.setState({offer_id: ''});
         }
      }

      let areFieldsFilled = Object.values(this.state)
      .filter(value => typeof value === 'string')
      .some(value => value !== '');
      let showNoPartnerButton = this.props.formData.isLeague || this.props.formData.allow_singles;

      return (
         <div>
            <Header headerBarTitle={t("registration_page.header")} showHeaderExtras showBackButton/>
            <Container className={"desktop"}>
               <Row>
                  <Col className={"pb-3"} xs={12} sm={12}>
                     <BulletHeader text={t("registration_page.player2_data")}/>
                     <p>{t("registration_page.check_player2_data")}</p>
                  </Col>
               </Row>
               <Row>
                  <Col xs={12} sm={12}>
                     <Input handleChange={this.handleChange} name="email" id="playerTwoEmail" inputType="email" text={t("common.form.labels.email")} inputTextValue={this.state.email}
                            disabled={this.state.searching || this.props.formData.is_replication}/>
                     <div className='sweet-loading'>
                        <ScaleLoader
                           css={override}
                           sizeUnit={"px"}
                           size={30}
                           color={'#AFFF55'}
                           loading={this.state.searching}
                        />
                     </div>
                     <Input handleChange={this.handleChange} name="name" id="playerTwoName" inputType="text" text={t("common.form.labels.name")} inputTextValue={this.state.name}
                            disabled={isFilled(this.state.original_details.name)}/>
                     <InputSelect labelClasses="label-style" inputType="text" text={t("common.form.labels.gender")}>
                        <select onChange={this.handleChange} value={this.state.gender !== '' ? this.state.gender : 'DEFAULT'} name="gender" className="input-background"
                                disabled={isFilled(this.state.original_details.gender)}>
                           <option value="DEFAULT" disabled>{t("common.form.options.choose_an_option")}</option>
                           <option value="Masculino">{t("common.form.options.male")}</option>
                           <option value="Feminino">{t("common.form.options.female")}</option>
                        </select>
                     </InputSelect>
                     <Input id="BirthYear" name="birthyear" text={t("common.form.labels.birth_year")} inputType="text" handleChange={this.handleChange} inputTextValue={this.state.birthyear}
                            disabled={isFilled(this.state.original_details.birthyear)}/>
                     <Input handleChange={this.handleChange} name="phone_number" labelClasses="label-style" id="playerTwoPhoneNumber" inputType="text" text={t("common.form.labels.phone_number")}
                            inputTextValue={this.state.phone_number} disabled={isFilled(this.state.original_details.phone_number)}/>
                     {this.props.formData.welcomepack_needed && <InputSelect text={t("common.form.labels.offer")}>
                        <select onChange={this.handleChange} value={this.state.offer_id !== '' ? this.state.offer_id : 'DEFAULT'} name="offer_id" style={{width: '100%', marginTop: 8}}
                                className="input-background">
                           <option value="DEFAULT" disabled>{t("common.form.options.choose_an_option")}</option>
                           {this.state.offers && this.state.offers.map((offer, index) => {
                              return <option key={index} value={offer.id}>{offer.offer_name}</option>
                           })}
                        </select>
                     </InputSelect>}
                     {this.state.offer_id !== '' && sizes.length !== 0 && this.props.formData.welcomepack_needed && <InputSelect text={t("common.form.labels.offer_size")}>
                        <select onChange={this.handleChange} value={this.state.offer_size_id !== '' ? this.state.offer_size_id : 'DEFAULT'} name="offer_size_id" style={{width: '100%', marginTop: 8}}
                                className="input-background">
                           <option value="DEFAULT" disabled>{t("common.form.options.choose_an_option")}</option>
                           {sizes.map((size, index) => {
                              return <option key={index} value={size.id}>{size.size_name}</option>
                           })}
                        </select>
                     </InputSelect>}
                     {this.props.formData.fpp_licence_needed &&
                        <InputRadio handleChange={this.handleChange} name="federated_fpp" text={t("common.form.labels.is_federated")} firstRadioText={t("common.yes")} secondRadioText={t("common.no")}
                                    checked={(this.state.federated_fpp || this.state.fpp_licence != '')} showInfoButton/>}
                     {(this.state.federated_fpp || this.state.fpp_licence != '') &&
                        <Input handleChange={this.handleChange} name="fpp_licence" id="fppLicence" inputType="text" text={t("common.form.labels.federative_license")}
                               inputTextValue={this.state.fpp_licence}/>}
                     <InputRadio handleChange={this.handleChange} name="social_media" isColumn={true} text={t("common.form.labels.social_networks")}
                                 firstRadioText={t("registration_page.social_networks_yes")} secondRadioText={t("registration_page.social_networks_no")}
                                 checked={(this.state.social_media || this.state.site_url != '')} disabled={isFilled(this.state.original_details.social_media)}/>

                     {(this.state.social_media || this.state.site_url != '') && <div style={{marginBottom: 20, marginTop: 20}} className="div-background-row align-row">
                        <Input handleChange={this.handleChange} text="facebook.com/" name="site_url" inputType="text" id="facebookUserName" inputTextValue={this.state.site_url}
                               disabled={isFilled(this.state.original_details.site_url)}/>
                     </div>}
                  </Col>
               </Row>
               <Row>
                  <Col xs={{span: 12, order: 1}} sm={{span: 6, offset: showNoPartnerButton ? 0 : 6, order: 12}} md={{offset: showNoPartnerButton ? 0 : 7, order: 12}}>
                     <Button onClick={() => {
                        this.submit({partner_registration: this.state})
                     }} className={"mt-2 mb-2 w-100"} variant="primary">{t("registration_page.next")}</Button>
                  </Col>

                  {showNoPartnerButton &&
                     <Col xs={{span: 12, order: 12}} sm={{span: 6, order: 1}} md={{order: 1}}>
                        <Button onClick={() => {
                           if (areFieldsFilled) {
                              NotificationManager.error(t("registration_page.errors.selected_no_partner_with_data"), t("common.attention"), 4000);
                           } else {
                              this.singleEnrollment();
                           }
                        }} className={"mt-2 mb-2 w-100"} variant="secondary">{t("registration_page.no_partner")}</Button>
                     </Col>
                  }
               </Row>
            </Container>

         </div>
      );
   }

   getLeaguePlayerDetails = async () => {
      const {t} = this.props;

      try {
         let partner_details = await getLeaguePlayerBDetails(this.props.formData.enrollment_id);

         let federated = partner_details.fpp_licence !== null && partner_details.fpp_licence !== ''
         let social_media = !!partner_details.social_media

         this.setState({
            original_details: partner_details,
            id: partner_details.id,
            email: partner_details.email === null ? '' : partner_details.email,
            name: partner_details.name === null ? '' : partner_details.name,
            phone_number: partner_details.phone_number === null ? '' : partner_details.phone_number,
            fpp_licence: partner_details.fpp_licence === null ? '' : partner_details.fpp_licence,
            site_url: partner_details.site_url === '' ? '' : "***",
            gender: partner_details.gender === null ? '' : partner_details.gender,
            birthyear: partner_details.birthyear ? "****" : '',
            federated_fpp: federated,
            offer_id: partner_details.offer_id === null ? '' : partner_details.offer_id,
            offer_size_id: partner_details.offer_size_id === null ? '' : partner_details.offer_size_id,
            social_media: social_media
         })
      } catch (e) {
         NotificationManager.error(t("common.form.errors.general"), t("common.error"), 4000);
      }
   }

   getSizesForOffer = (offer_id) => {
      var sizes = []
      this.state.offers.map((offer) => {
         if (offer.id == offer_id) {
            if (offer.sizes[0].size_name !== "GENERIC") {
               sizes = offer.sizes
            }
         }
      })
      return sizes;
   }

   getTournamentPlayerDetails = async () => {
      const {t} = this.props;

      try {
         let partner_details = await connection.post(`v1/tournament_registrations/${this.props.formData.registration_id}/player_b_details`)

         let federated = partner_details.fpp_licence != null && partner_details.fpp_licence != ''
         let social_media = !!partner_details.social_media

         this.setState({
            original_details: partner_details,
            id: partner_details.id,
            email: partner_details.email === null ? '' : partner_details.email,
            name: partner_details.name === null ? '' : partner_details.name,
            phone_number: partner_details.phone_number === null ? '' : partner_details.phone_number,
            fpp_licence: partner_details.fpp_licence === null ? '' : partner_details.fpp_licence,
            site_url: partner_details.site_url === '' ? '' : "***",
            gender: partner_details.gender === null ? '' : partner_details.gender,
            birthyear: partner_details.birthyear ? "****" : '',
            federated_fpp: federated,
            offer_id: partner_details.offer_id === null ? '' : partner_details.offer_id,
            offer_size_id: partner_details.offer_size_id === null ? '' : partner_details.offer_size_id,
            social_media: social_media
         })
      } catch (e) {
         NotificationManager.error(t("common.form.errors.general"), t("common.error"), 4000);
      }
   }

   getOffers = async () => {
      const {t} = this.props;

      try {
         if (this.props.formData.isLeague) {
            let offers = await getOffersForLeague(this.props.formData.id)
            this.setState({offers})
         } else {
            let offers = await getOffersForTournament(this.props.formData.id)
            this.setState({offers})
         }

      } catch (e) {
         NotificationManager.error(t("common.form.errors.general"), t("common.error"), 4000);
      }
   }

   singleEnrollment = () => {
      const {t} = this.props;

      if (this.props.formData.allow_singles) {
         this.setState({single_enrollment: true}, () => this.props.onSubmit({single_enrollment: this.state.single_enrollment}))
      } else {
         MySwal.fire({
            titleText: t("registration_page.tournament_no_partner_popup.title"),
            text: t("registration_page.tournament_no_partner_popup.content")
         })
      }
   }

   handleChange = (event) => {
      if (event.target.name === "social_media") {
         if (!event.target.value) {
            this.setState({site_url: ''});
         }
      }
      if (event.target.name === "federated_fpp") {
         if (!event.target.value) {
            this.setState({fpp_licence: ''});
         }
      }

      if (event.target.name === "email") {
         if (this.timeout) {
            clearTimeout(this.timeout);
         }
         let email = event.target.value;
         this.timeout = setTimeout(() => {
            this.setState({
               searching: true,
               found: false,
               free_email: false
            });

            let values = {
               email: email,
               league_edition_id: this.props.formData.id,
               league_id: this.props.formData.league_id,
               league_category_id: this.props.formData.league_category_id,
               league_division_id: this.props.formData.league_division_id
            }

            this.searchUser(values.email);
         }, 3000);
      }
      this.setState({
         [event.target.name]: event.target.value
      });
   }

   searchUser = async (email) => {
      const {t} = this.props;

      try {
         let user_details = await searchUser(email);
         if (user_details === "NOT_FOUND") {
            MySwal.fire({
               showCancelButton: true,
               titleText: t("registration_page.new_player"),
               text: t("registration_page.player_not_found"),
               confirmButtonText: t("registration_page.continue"),
               cancelButtonText: t("registration_page.fix_email")
            }).then((res) => {
               let filtered_email = email.toLowerCase();

               if (res.dismiss == 'cancel') {
                  filtered_email = '';
               }

               this.setState({
                  original_details: {},
                  id: '',
                  name: '',
                  email: filtered_email,
                  gender: '',
                  birthyear: '',
                  federated_fpp: false,
                  fpp_licence: '',
                  site_url: '',
                  phone_number: '',
                  social_media: false,
                  offer_id: '',
                  offer_size_id: '',
                  searching: false,
                  found: false,
                  free_email: true
               });
            });
         } else {
            let federated = user_details.fpp_licence !== null && user_details.fpp_licence !== ''
            let social_media = !!user_details.social_media

            this.setState({
               original_details: user_details,
               id: user_details.id,
               name: user_details.name === null ? '' : user_details.name,
               email: user_details.email,
               gender: user_details.gender === null ? '' : user_details.gender,
               birthyear: user_details.birthyear ? "****" : '',
               offer_id: typeof user_details.offer_id === 'undefined' ? '' : user_details.offer_id,
               offer_size_id: typeof user_details.offer_size_id === 'undefined' ? '' : user_details.offer_size_id,
               federated_fpp: federated,
               fpp_licence: user_details.fpp_licence === null ? '' : user_details.fpp_licence,
               site_url: user_details.site_url === '' ? '' : "***",
               phone_number: user_details.phone_number === null ? '' : user_details.phone_number,
               social_media: social_media,
            })

            this.setState({
               searching: false,
               found: true,
               free_email: false
            });
         }
      } catch (e) {
         NotificationManager.error(t("common.form.errors.general"), t("common.error"), 4000);
      }
   }

   submit = (data) => {
      const {t} = this.props;

      if (this.verifyPlayerData()) {
         if (this.state.free_email && Object.keys(this.props.formData.user_registration.original_details).length !== 0) {
            MySwal.fire({
               titleText: t("registration_page.new_user"),
               html: `<div>
                        <label class='swal-content mb-0'>${t("registration_page.new_user_alert")}</label>
                        <textarea id='newPlayerEval' class='cancel-popup-input d-flex swal2-textarea'></textarea>
                     </div>`,
               showCancelButton: true,
               cancelButtonText: t("common.cancel"),
               confirmButtonText: t("registration_page.next"),
               preConfirm: () => {
                  let newPlayerEval = document.getElementById("newPlayerEval").value;

                  if (newPlayerEval === "") {
                     NotificationManager.error(t("registration_page.errors.input_mandatory"), t("common.error"), 4000);
                     return false;
                  }
               }
            }).then(async (res) => {
               if (res.value) {
                  let info_new_player = document.getElementById("newPlayerEval").value;
                  this.setState({info_new_player});
                  this.props.onSubmit({partner_registration: this.state})
               } else if (res.dismiss === MySwal.DismissReason.cancel) {
                  MySwal.close();
               }
            })
         } else {
            this.props.onSubmit(data);
         }
      }
   }

   verifyPlayerData = () => {
      const {t} = this.props;
      let isAcceptable = true

      if (this.state.email === '') {
         isAcceptable = false
         NotificationManager.error(t("registration_page.errors.email_mandatory"), t("common.error"), 4000);
         return isAcceptable
      } else {
         if (!/^[^@]+@[^@]+\.[^@]+$/.test(this.state.email)) {
            isAcceptable = false
            NotificationManager.error(t("registration_page.errors.email_invalid"), t("common.error"), 4000);
            return isAcceptable
         }

         if (this.state.email === this.props.formData.user_registration.email) {
            isAcceptable = false
            NotificationManager.error(t("registration_page.errors.different_player_email"), t("common.error"), 4000)
            return isAcceptable
         }
      }

      if (this.state.name === '') {
         isAcceptable = false
         NotificationManager.error(t("registration_page.errors.name_mandatory"), t("common.error"), 4000);
         return isAcceptable
      }

      if (this.state.birthyear === '') {
         isAcceptable = false
         NotificationManager.error(t("registration_page.errors.birthyear_mandatory"), t("common.error"), 4000);
         return isAcceptable
      } else {
         if (!/^[0-9]+$/.test(this.state.birthyear) && !isFilled(this.state.original_details.birthyear)) {
            isAcceptable = false
            NotificationManager.error(t("registration_page.errors.birthyear_invalid_spaces"), t("common.error"), 4000);
            return isAcceptable
         }

         if (!(parseInt(this.state.birthyear) > moment().year() - 70 && parseInt(this.state.birthyear) < moment().year() - 12) && !isFilled(this.state.original_details.birthyear)) {
            isAcceptable = false
            NotificationManager.error(t("common.form.errors.invalid_year"), t("common.error"), 4000);
            return isAcceptable;
         }
      }

      if (this.state.phone_number === '') {
         isAcceptable = false
         NotificationManager.error(t("registration_page.errors.phone_mandatory"), t("common.error"), 4000);
         return isAcceptable
      } else {
         if (!isFilled(this.state.original_details.phone_number)) {
            if (/^351/.test(this.state.phone_number)) {
               isAcceptable = false
               NotificationManager.error(t("registration_page.errors.phone_country_prefix"), t("common.error"), 4000);
               return isAcceptable
            }

            if (this.state.phone_number.length < 9) {
               isAcceptable = false
               NotificationManager.error(t("common.form.errors.invalid_phone_number"), t("common.error"), 4000);
               return isAcceptable
            }

            if (!/^[0-9]+$/.test(this.state.phone_number)) {
               isAcceptable = false
               NotificationManager.error(t("common.form.errors.special_characters"), t("common.error"), 4000);
               return isAcceptable
            }
         }
      }

      if (this.props.formData.welcomepack_needed && this.state.offer_id === '') {
         isAcceptable = false
         NotificationManager.error(t("registration_page.errors.offer_mandatory"), t("common.error"), 4000);
         return isAcceptable
      }

      if (this.props.formData.welcomepack_needed && this.state.offer_size_id === '') {
         isAcceptable = false
         NotificationManager.error(t("registration_page.errors.offer_size_mandatory"), t("common.error"), 4000);
         return isAcceptable
      }

      if (this.props.formData.fpp_licence_needed) {
         if (this.state.federated_fpp) {
            if (this.state.fpp_licence === '' || isNaN(this.state.fpp_licence)) {
               isAcceptable = false
               NotificationManager.error(t("registration_page.errors.license_mandatory"), t("common.error"), 4000);
               return isAcceptable
            } else {
               if (/\s/.test(this.state.fpp_licence)) {
                  isAcceptable = false
                  NotificationManager.error(t("registration_page.errors.license_invalid"), t("common.error"), 4000);
                  return isAcceptable
               }
            }
         }
      }

      if (this.state.social_media) {
         if (this.state.site_url === '') {
            isAcceptable = false
            NotificationManager.error(t("registration_page.errors.facebook_mandatory"), t("common.error"), 4000);
            return isAcceptable
         } else {
            if (!/^[A-Za-z0-9.]*$/.test(this.state.site_url) && !isFilled(this.state.original_details.site_url)) {
               isAcceptable = false
               NotificationManager.error(t("registration_page.errors.facebook_invalid"), t("common.error"), 4000);
               return isAcceptable
            }
         }
      }

      if (this.state.gender === '') {
         isAcceptable = false
         NotificationManager.error(t("registration_page.errors.gender_mandatory"), t("common.error"), 4000);
         return isAcceptable
      } else {
         let category = this.props.formData.isLeague ? this.props.formData.category : this.props.formData.category_name
         let playerOneGender = this.props.formData.user_registration.gender
         let playerTwoGender = this.state.gender

         if (category.includes('Feminino')) {
            if (playerOneGender !== "Feminino" || playerTwoGender !== "Feminino") {
               isAcceptable = false
               NotificationManager.error(t("registration_page.errors.gender_not_accepted"), t("common.error"), 4000)
               return isAcceptable
            }
         } else {
            if (category.includes('Mistos')) {
               if (!((playerOneGender === "Masculino" && playerTwoGender === "Feminino") || (playerOneGender === "Feminino" && playerTwoGender === "Masculino"))) {
                  isAcceptable = false
                  NotificationManager.error(t("registration_page.errors.gender_not_accepted"), t("common.error"), 4000)
                  return isAcceptable
               }
            }
         }
      }

      return isAcceptable
   }
}

export default withTranslation()(PlayerTwoRegistration);
